<template>

		<div ref="global-message-container">

				<p v-for="message in messages" :class='"alert alert-" + message.type + " alert-dismissible"'>
					{{ message.content }}
					<a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
				</p>
		</div>

</template>

<script>
	export default {
		// Supported message types are:
		// danger, warning, success, info
		props: [
		],
		data: function(){
			return {
				messages: []
			};
		},
		mounted() {
		},
		methods: {
		}
    }
</script>
